import type { FC } from "react";
import type {
  TTableSortModel,
  IMultiSortModel,
  ISortModel,
} from "../model/types";
import TableMultiSort from "./TableMultiSort";
import TableSingleSort from "./TableSingleSort";

const TableSort: FC<{ sortModel: TTableSortModel }> = ({ sortModel }) => {
  if ((sortModel as unknown as IMultiSortModel).mode === "multi") {
    return <TableMultiSort model={sortModel as IMultiSortModel} />;
  }

  return <TableSingleSort sortModel={sortModel as ISortModel} />;
};

export default TableSort;
